export default {
    /**
     * 
     * @param {*} type 
     * @param {*} version 
     * @returns Promise
     */
    acceptTerms(type, version) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.put(`/rest/terms/${type}`, {}, {version}, 
                res => resolve(res),
                err => reject(err.response.data.error.message)
            );
        })
    }
}